import { asyncActionType } from "utils/constants";

export const GET_BRAND_COPY = asyncActionType("GET_BRAND_COPY");
